var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_1483_9033)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28476 14.4443H5.45045C5.06501 14.4443 4.87462 14.4443 4.75853 14.3676C4.63314 14.2837 4.55652 14.1446 4.54723 13.9911C4.54026 13.8497 4.63547 13.6769 4.82586 13.3316L9.35499 5.08643C9.54771 4.7363 9.64522 4.56124 9.76828 4.49649C9.90063 4.42695 10.0585 4.42695 10.1909 4.49649C10.3139 4.56124 10.4115 4.7363 10.6042 5.08643L11.5353 6.7651L11.54 6.77366C11.7482 7.14928 11.8537 7.33976 11.8998 7.53968C11.9509 7.75791 11.9509 7.98812 11.8998 8.20635C11.8534 8.40779 11.7489 8.59965 11.5376 8.98094L9.15854 13.3244L9.15239 13.3355C8.94286 13.7143 8.83668 13.9062 8.68952 14.051C8.52931 14.2093 8.33658 14.3244 8.12529 14.3892C7.93257 14.4443 7.71664 14.4443 7.28476 14.4443ZM11.917 14.4443H14.5453C14.9331 14.4443 15.1282 14.4443 15.2443 14.3653C15.3697 14.2813 15.4486 14.1398 15.4556 13.9864C15.4623 13.8495 15.3692 13.6835 15.1867 13.3583C15.1804 13.3472 15.1741 13.3359 15.1677 13.3245L13.8511 10.9983L13.8361 10.9721C13.6511 10.649 13.5577 10.4858 13.4378 10.4228C13.3055 10.3532 13.1498 10.3532 13.0176 10.4228C12.8968 10.4875 12.7993 10.6578 12.6066 11.0007L11.2947 13.3269L11.2902 13.3349C11.0982 13.6773 11.0022 13.8484 11.0091 13.9887C11.0184 14.1423 11.095 14.2837 11.2204 14.3676C11.3342 14.4443 11.5292 14.4443 11.917 14.4443Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1483_9033",
    x1: 20,
    y1: 20,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D91D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7576"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.5cbace26aa45f297eae00286445c1f75.svg";
export { ForwardRef as ReactComponent };